module.exports = __webpack_public_path__ + "media/images/stat-cards-today-1ccfc0b3.svg";